import { render, staticRenderFns } from "./Facts.vue?vue&type=template&id=11124de6&scoped=true"
import script from "@/views/Facts/Facts.ts?vue&type=script&lang=ts&external"
export * from "@/views/Facts/Facts.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Facts/facts.scss?vue&type=style&index=0&id=11124de6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11124de6",
  null
  
)

export default component.exports